import { Dispatch, SetStateAction } from "react";
import { Button } from "../Button";

type ChatbotWidgetProps = {
  setShowWindow: Dispatch<SetStateAction<boolean>>;
};
export const ChatbotWidget = ({ setShowWindow }: ChatbotWidgetProps) => {
  return (
    <Button
      variant="null"
      className="right-4 size-14 cursor-pointer rounded-full bg-[#01375F] p-4"
      onClick={() => setShowWindow((prev) => !prev)}
    >
      <ChatCircleHelp />
    </Button>
  );
};

export const ChatCircleHelp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.486 16.803C21.3149 15.338 21.7504 13.6832 21.75 11.9999C21.7494 10.5189 21.4114 9.05741 20.7616 7.7265C20.1119 6.39558 19.1675 5.23018 18.0001 4.31875C16.8327 3.40733 15.473 2.77383 14.0242 2.46635C12.5754 2.15886 11.0756 2.18548 9.63869 2.54416C8.20173 2.90285 6.86537 3.58419 5.73105 4.53646C4.59672 5.48873 3.69425 6.6869 3.09213 8.04003C2.49001 9.39316 2.20406 10.8657 2.256 12.3458C2.30793 13.826 2.69639 15.2748 3.39187 16.5824L2.32781 19.7746C2.23967 20.0389 2.22688 20.3225 2.29087 20.5937C2.35486 20.8648 2.49311 21.1128 2.69011 21.3098C2.88711 21.5068 3.13509 21.645 3.40624 21.709C3.6774 21.773 3.96102 21.7602 4.22531 21.6721L7.4175 20.608C8.9033 21.3992 10.5686 21.7922 12.2514 21.7488C13.9341 21.7054 15.577 21.2271 17.02 20.3604C18.4631 19.4937 19.6572 18.2681 20.486 16.803ZM12 6.74988C9.93188 6.74988 8.25 8.26394 8.25 10.1249V10.4999C8.25 10.6988 8.32902 10.8896 8.46967 11.0302C8.61032 11.1709 8.80109 11.2499 9 11.2499C9.19891 11.2499 9.38968 11.1709 9.53033 11.0302C9.67098 10.8896 9.75 10.6988 9.75 10.4999V10.1249C9.75 9.09363 10.7597 8.24988 12 8.24988C13.2403 8.24988 14.25 9.09363 14.25 10.1249C14.25 11.1561 13.2403 11.9999 12 11.9999C11.8011 11.9999 11.6103 12.0789 11.4697 12.2195C11.329 12.3602 11.25 12.551 11.25 12.7499V13.4999C11.25 13.6988 11.329 13.8896 11.4697 14.0302C11.6103 14.1709 11.8011 14.2499 12 14.2499C12.1989 14.2499 12.3897 14.1709 12.5303 14.0302C12.671 13.8896 12.75 13.6988 12.75 13.4999V13.4324C14.46 13.1183 15.75 11.7543 15.75 10.1249C15.75 8.26394 14.0681 6.74988 12 6.74988ZM13.125 16.8749C13.125 17.0974 13.059 17.3149 12.9354 17.4999C12.8118 17.6849 12.6361 17.8291 12.4305 17.9142C12.225 17.9994 11.9988 18.0217 11.7805 17.9783C11.5623 17.9349 11.3618 17.8277 11.2045 17.6704C11.0472 17.513 10.94 17.3126 10.8966 17.0944C10.8532 16.8761 10.8755 16.6499 10.9606 16.4444C11.0458 16.2388 11.19 16.0631 11.375 15.9395C11.56 15.8159 11.7775 15.7499 12 15.7499C12.2984 15.7499 12.5845 15.8684 12.7955 16.0794C13.0065 16.2904 13.125 16.5765 13.125 16.8749Z"
        fill="white"
      />
    </svg>
  );
};
